import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { ResellersActions, LocationsActions, BusinessActions } from '@actions/index'
import * as fromResellers from '@reducers/index'
import { Observable } from 'rxjs';
import { ResellerModel } from '@models/index';
import { addRandomImageToReseller } from '@utilities/function-utils';
import { emptyLocationModel, emptyBusinessModel } from '@utilities/data-utils';

@Injectable({
  providedIn: 'root'
})
export class ResellersFacadeService {

  constructor(private store: Store<any>) { }

  getResellers$(): Observable<ResellerModel[]> {
    return this.store
      .select(fromResellers.getResellers)
      .pipe(
        map(items => items
          .map(addRandomImageToReseller)
        ),
      )
  }

  getResellersByQuery$(): Observable<ResellerModel[]> {
    return this.store
      .select(fromResellers.getFilterResellers)
      .pipe(
        map(items => items
          .map(addRandomImageToReseller)
        ),
      )
  }

  getSelectedReseller$(): Observable<ResellerModel> {
    return this.store.select(fromResellers.getSelectedResellerProfile)
  }

  getResellerError$(): Observable<string> {
    return this.store.select(fromResellers.getErrorResellers)
  }

  editReseller(reseller: ResellerModel) {
    this.store.dispatch(ResellersActions.editReseller({ reseller }))
  }

  editResellerAvailableLicenses(reseller: ResellerModel) {
    this.store.dispatch(ResellersActions.editResellerAvailableLicenses({ reseller }))
  }

  deleteReseller(resellerId: string) {
    this.store.dispatch(ResellersActions.deleteReseller({ resellerId }))
  }

  archiveReseller(resellerId: string) {
    this.store.dispatch(ResellersActions.archiveReseller({ resellerId }))
  }

  selectResellerPorfile(reseller: ResellerModel) {
    this.store.dispatch(ResellersActions.selectResellerProfile({ reseller }))
    this.store.dispatch(BusinessActions.selectBusinessProfile({ business: emptyBusinessModel() }))
    this.store.dispatch(LocationsActions.setCurrentLocation({ location: emptyLocationModel() }))
  }

  clearSelectedReseller() {
    this.store.dispatch(ResellersActions.clearSelectedReseller())
  }

}
